import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CustomCurrencyPipe } from "./currency/currency.pipe";
import { EmploymentTypePipe } from "./employment-type/employment-type.pipe";
import { RelocationPipe } from "./relocation/relocation.pipe";
import { SalaryPeriodPipe } from "./salary-period/salary-period.pipe";
import { WorkplacePipe } from "./workplace/workplace.pipe";
import { SafeHtmlPipe } from "./safe-html/safe-html.pipe";
import { StripHtmlPipe } from "./strip-html/strip-html.pipe";
import { BytesConverterPipe } from "./bytes-converter/bytes-converter.pipe";
import { SalaryDividerPipe } from "./salary-divider/salary-divider.pipe";
import { UrlHttpsPipe } from "./url-https/url-https.pipe";
import { RandomTextPipe } from "./random-text/random-text.pipe";
import { SalaryPipe } from "./salary/salary.pipe";

const pipes = [
  CustomCurrencyPipe,
  SalaryPeriodPipe,
  EmploymentTypePipe,
  RelocationPipe,
  WorkplacePipe,
  SafeHtmlPipe,
  StripHtmlPipe,
  BytesConverterPipe,
  SalaryDividerPipe,
  UrlHttpsPipe,
  RandomTextPipe,
  SalaryPipe
];

@NgModule({
  declarations: [ ...pipes ],
  imports: [ 
    CommonModule
   ],
  exports: [ ...pipes ]
})

export class SharedPipesModule {};
